import { render } from "./InitiativeRateTable.vue?vue&type=template&id=67673c10&scoped=true"
import script from "./InitiativeRateTable.vue?vue&type=script&lang=js"
export * from "./InitiativeRateTable.vue?vue&type=script&lang=js"

import "./InitiativeRateTable.vue?vue&type=style&index=0&id=67673c10&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67673c10"]])

export default __exports__